export const hasLink = (link) => link.link !== undefined && link.link !== null
